// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"465":"bes","535":"login"}[chunkId] + "." + {"465":"64651020","535":"96b61bec"}[chunkId] + ".css";
};